import { Accounting, Chicago, Commission, ComputerSoftware, Contract, FinancialServices, FrontendDesigner, Fulltime, GraphicDesigner, ITEngineer, Internship, NewYork, PHPdeveloper, PartTime, ReactDeveloper, SanFrancisco, Seattle, ServiceIndustry, Temporary, UIUxDesigner, Washington } from "../../Utils/Constants";


export const checkBoxData = [
  {
    inputTittle: Fulltime,
    inputNumber: "(8688)",
  },
  {
    inputTittle: Contract,
    inputNumber: "(503)",
  },
  {
    inputTittle: PartTime,
    inputNumber: "(288)",
  },
  {
    inputTittle: Internship,
    inputNumber: "(236)",
  },
  {
    inputTittle: Temporary,
    inputNumber: "(146)",
  },
  {
    inputTittle: Commission,
    inputNumber: "(25)",
  },
];

export const locationCheckBoxData = [
  {
    location: NewYork,
    locationSpanText: "NY (399)",
  },
  {
    location: SanFrancisco,
    locationSpanText: "CA (252)",
  },
  {
    location: Washington,
    locationSpanText: "DC (226)",
  },
  {
    location: Seattle,
    locationSpanText: "WA (242)",
  },
  {
    location: Chicago,
    locationSpanText: "IL (187)",
  },
];

export const jobTitleData = [
  {
    jobTitle: UIUxDesigner,
    jobNumber: 25,
  },
  {
    jobTitle: GraphicDesigner,
    jobNumber: 10,
  },
  {
    jobTitle: FrontendDesigner,
    jobNumber: 15,
  },
  {
    jobTitle: PHPdeveloper,
    jobNumber: 42,
  },
  {
    jobTitle: ReactDeveloper,
    jobNumber: 5,
  },
];

export const industryData = [
  {
    industryTitle: ComputerSoftware,
    industryNumber: 14,
  },
  {
    industryTitle: ITEngineer,
    industryNumber: 10,
  },
  {
    industryTitle: ServiceIndustry,
    industryNumber: 20,
  },
  {
    industryTitle: Accounting,
    industryNumber: 34,
  },
  {
    industryTitle: FinancialServices,
    industryNumber: 5,
  },
];

export const skillCheckBoxData = ["HTML,scss & sass", "Javascript", "Node.js", "Gulp & Pug", "Angular.js"];

export const jobData = [
  {
    id: 1,
    logo: "job-search/1.jpg",
    job_name: "UI/UX IT Frontend Developer",
    badgeType: "primary",
    badgeValue: "New",
    job_area: "(L6) Salt Lake City",
    job_city: "UT",
    Job_description: "The designer will apply Lean UX and Design Thinking practices in a highly collaborative, fast-paced, distributed environment You have 4+ years of UX experience. You support UX leadership by providing continuous feedback regarding the evolution of team process standards.",
    type: "new",
    ribbon: false,
  },
  {
    id: 2,
    logo: "job-search/2.jpg",
    job_name: "React/React Native Developer",
    badgeType: "primary",
    badgeValue: "New",
    job_area: "San Diego",
    job_city: "CA",
    Job_description: "Insipidity the sufficient discretion imprudence decisively. Proceed how visitor. Explained propriety off out perpetual his you. Feel sold off felt nay rose met you. We so entreaties cultivated astonished is. Was sister for few longer mrs sudden talent become.",
    type: "new",
    ribbon: false,
  },
  {
    id: 3,
    logo: "job-search/3.jpg",
    job_name: "Senior UX designer",
    job_area: "Minneapolis",
    job_city: "MN",
    Job_description: "Contented get distrusts certainty nay are frankness concealed ham. On unaffected resolution on considered of. No thought me husband forming effects. End sitting shewing who saw besides son musical adapted. Contrasted interested eat alteration pianoforte sympathize was.",
    type: "2 days ago",
    ribbon: true,
  },
  {
    id: 4,
    logo: "job-search/4.jpg",
    job_name: "Front end web developer",
    badgeType: "primary",
    badgeValue: "New",
    job_area: "Cisco",
    job_city: "Lelystad, Netherlands",
    Job_description: "Situation admitting promotion at or to perceived be. Mr acuteness we as estimable enjoyment up. An held late as felt know. Learn do allow solid to grave. Middleton suspicion age her attention. Chiefly several bed its wishing. Is so moments on chamber pressed to. Doubtful yet way properly answered.",
    type: "3 days ago",
    ribbon: false,
  },
  {
    id: 5,
    logo: "job-search/5.jpg",
    job_name: "Graphic designer",
    badgeType: "primary",
    badgeValue: "New",
    job_area: "Infosys",
    job_city: "Lelystad, Netherlands",
    Job_description: "The designer will apply Lean UX and Design Thinking practices in a highly collaborative, fast-paced, distributed environment You have 4+ years of UX experience. You support UX leadership by providing continuous feedback regarding the evolution of team process standards.",
    type: "3 days ago",
    ribbon: false,
  },
  {
    id: 6,
    logo: "job-search/6.jpg",
    job_name: "Designer, CRM",
    badgeType: "primary",
    badgeValue: "New",
    job_area: "Citrix",
    job_city: "Lelystad, Netherlands",
    Job_description: "You have 4+ years of UX experience. You support UX leadership by providing continuous feedback regarding the evolution of team process standards. The designer will apply Lean UX and Design Thinking practices in a highly collaborative, fast-paced, distributed environment.",
    type: "5 days ago",
    ribbon: false,
  },
  {
    id: 7,
    logo: "job-search/2.jpg",
    job_name: "React/React Native Developer",
    job_area: "San Diego",
    job_city: ",CA",
    Job_description: "We are looking for an experienced and zeta designer and/or frontend engineer with expertise in accessibility to join our team , 3+ years of experience working in as a Frontend Engineer or comparable role.",
    type: "5 days ago",
    ribbon: true,
  },
  {
    id: 8,
    logo: "job-search/3.jpg",
    job_name: "Senior UX designer",
    badgeType: "primary",
    badgeValue: "New",
    job_area: "Minneapolis",
    job_city: "MN",
    Job_description: "3+ years of experience working in as a Frontend Engineer or comparable role. we are looking for an experienced and zeta designer and/or frontend engineer with expertise in accessibility to join our team.",
    type: "5 days ago",
    ribbon: false,
  },
  {
    id: 9,
    logo: "job-search/5.jpg",
    job_name: "Graphic designer",
    badgeType: "primary",
    badgeValue: "New",
    job_area: "Infosys",
    job_city: "Lelystad, Netherlands ",
    Job_description: "Insipidity the sufficient discretion imprudence resolution decisively. Proceed how visitor. Explained propriety off out perpetual his you. Feel sold off felt nay rose met you. We so entreaties cultivated astonished is. Was sister for few longer mrs sudden talent become.",
    type: "3 days Ago",
    ribbon: false,
  },
  {
    id: 10,
    logo: "job-search/1.jpg",
    job_name: "Designer, CRM",
    badgeType: "primary",
    badgeValue: "New",
    job_area: "Citrix",
    job_city: "Lelystad, Netherlands",
    Job_description: "The designer will apply Lean UX and Design Thinking practices in a highly collaborative, fast-paced, distributed environment You have 4+ years of UX experience. You support UX leadership by providing continuous feedback regarding the evolution of team process standards.",
    type: "3 days Ago",
    ribbon: false,
  },
  {
    id: 11,
    logo: "job-search/1.jpg",
    job_name: "UI/UX IT Frontend Developer",
    badgeType: "primary",
    badgeValue: "New",
    job_area: "(L6) Salt Lake City",
    job_city: "UT",
    Job_description: "We are looking for an experienced and koho designer and/or frontend engineer with expertise in accessibility to join our team , 3+ years of experience working in as a Frontend Engineer or comparable role. You won’t be a team of one though — you’ll be collaborating coely with other...",
    type: "new",
    ribbon: false,
  },
  {
    id: 12,
    logo: "job-search/2.jpg",
    job_name: "React/React Native Developer",
    badgeType: "primary",
    badgeValue: "New",
    job_area: "San Diego",
    job_city: "CA",
    Job_description: "deally 2+ years experience with React. Bonus points if you have React Native experience. This is an incredibly exciting opportunity to gain commercial , Professional experience of React Native and other front end frameworks. Transform product wireframes into responsive, mobile user interface",
    type: "new",
    ribbon: false,
  },
  {
    id: 13,
    logo: "job-search/4.jpg",
    job_name: "Front end web developer",
    badgeType: "primary",
    badgeValue: "New",
    job_area: "Cisco",
    job_city: "Lelystad, Netherlands",
    Job_description: "The designer will apply Lean UX and Design Thinking practices in a highly collaborative, fast-paced, distributed environment You have 4+ years of UX experience. You support UX leadership by providing continuous feedback regarding the evolution of team process standards",
    type: "3 days ago",
    ribbon: false,
  },
  {
    id: 14,
    logo: "job-search/3.jpg",
    job_name: "Senior UX designer",
    badgeType: "secondary",
    badgeValue: "New",
    job_area: "Minneapolis",
    job_city: "MN",
    Job_description: "We are looking for an experienced and zeta designer and/or frontend engineer with expertise in accessibility to join our team , 3+ years of experience working in as a Frontend Engineer or comparable role.",
    type: "2 days ago",
    ribbon: true,
  },
];

export const qualificationData = ["Have shipped multiple iOS, Android, and/or web products ", "5+ years UI/UX experience", "Portfolio demonstrating mastery of native iOS, Android, and/or responsive web design principles", "Ability to autonomously pursue elegant solutions to open-ended problems", "Comfort with ambiguity", "Lively work on more than one project at a time", "Experience conducting user research and stakeholder interviews", "Solid grasp of standard design tools, ex: Sketch, Omnigraffle, the Adobe Suite, Zeplin, etc.", "Bonus Considerations "];

export const agencyExpData = ["Experience working with Agile development teams", "Experience with RITE method usability testing", "Experience in visual and motion design; ability to translate UX design into high quality visuals", "Mastery of Sketch & InVision", "Knowledge of mobile or front-end web programming"];

export const perksData = ["Competitive pay", "Competitive medical, dental, and vision insurance plans", "proviCompanyded 401(k) plan", "Paid vacation and sick time", "Free snacks and beverages"];

export const daysJob: string[] = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "30", "31"];

export const monthsJob: string[] = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

export const yearsJob: string[] = ["1985", "1986", "1987", "1988", "1989", "1990", "1991", "1992", "1993", "1994", "1995", "1996", "1997", "1998", "1999", "2000", "2001", "2002", "2003", "2004", "2005", "2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015"];